<template>
    <header class="w-full fixed inset-x-0 z-100">
        <div
            class="h-22.5 space-x-10 flex items-center justify-end border-b border-gray-50 dark:border-purple-light mr-8 bg-white dark:bg-purple transition-spacing duration-150 ease-in-out"
            :class="mini ? 'ml-31' : 'ml-76'"
        >
            <NotificationMenu />

            <ThemeToggle />

            <AccountMenu />
        </div>
    </header>
</template>

<script>
import AccountMenu from '@/components/menu/AccountMenu'
import NotificationMenu from '@/components/menu/NotificationMenu'
import ThemeToggle from '@/components/buttons/ThemeToggle'

export default {
    name: 'AppBar',
    components: { AccountMenu, NotificationMenu, ThemeToggle },
    props: {
        mini: {
            type: Boolean,
            default: true
        },
    },
}
</script>
